import { render } from "./AddMain.vue?vue&type=template&id=033b897b&scoped=true"
const script = {}

import "./../../../assets/styles/admin/add.scss?vue&type=style&index=0&id=033b897b&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033b897b"]])

export default __exports__